import ApiService from '../../utils/ApiService';
import Urls from '../../utils/Urls';
import * as Func from '../../utils/functions';
import {removeObjectNull} from "../../utils/functions";
import SubscriptionTransactionResponse, {
    MasterTransactionResponse
} from "../mapping/Response/SubscriptionTransactionResponse";

export function getListSubscriptionTransactions(params, options) {
    return new ApiService({
        baseURL: process.env.REACT_APP_API_URL,
        endpoint: Urls.SUBSCRIPTION_TRANSACTION_LIST,
        params: params,
        ...options,
        parser: data => params?.is_export ? data : {
            ...data.data,
            result: (data.data.result || []).map(item => new SubscriptionTransactionResponse(item).exportList()),
            total_page: Math.ceil(parseInt(data.data.total) / parseInt(data.data.page_size))
        }
    }).get();
}

export function masterData() {
    return new ApiService({
        baseURL: process.env.REACT_APP_API_URL,
        endpoint: Urls.SUBSCRIPTION_TRANSACTION_MASTER_DATA,
        // params: removeObjectNull({ city_id }),
        parser: data => new MasterTransactionResponse(data.data.result).exportListMaster(),
    }).get();
}

export function update(data) {
    return new ApiService({
        baseURL: process.env.REACT_APP_API_URL,
        endpoint: Urls.SUBSCRIPTION_TRANSACTION_UPDATE,
        endpointParams: {id: data?.id},
        parser: data => data?.data?.result
    }).put(data);
}

function dataParser(data = {}) {
    return {
        ...data.data,
        result: (data.data.result || []).map(item => new SubscriptionTransactionResponse(item).exportList()),
        total_page: Math.ceil(parseInt(data.data.total) / parseInt(data.data.page_size))
    }
}
